import { ShieldAlert } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/modules/shared/ui/components/card";
import { Button } from "@/modules/shared/ui/components/custom/button";
import { Alert, AlertDescription, AlertTitle } from "@/modules/shared/ui/components/alert";
import { useGracePeriodInfo } from "../../hooks/use-grace-period-info";

export function AccountSuspended() {
  const { data: gracePeriodInfo } = useGracePeriodInfo();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <ShieldAlert className="h-16 w-16 text-destructive" />
          </div>
          <CardTitle className="text-2xl">Account Suspended</CardTitle>
          <CardDescription>
            Your account has been suspended due to payment issues.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {gracePeriodInfo && (
            <Alert variant="destructive">
              <AlertTitle>Payment Failure Details</AlertTitle>
              <AlertDescription className="space-y-1">
                <p>Failed attempts: {gracePeriodInfo.failedAttempts}</p>
                {gracePeriodInfo.lastFailureReason && (
                  <p>Last failure: {gracePeriodInfo.lastFailureReason}</p>
                )}
              </AlertDescription>
            </Alert>
          )}

          <div className="space-y-3">
            <Button className="w-full" asChild>
              <a href="/billing">Update Payment Method</a>
            </Button>
            <Button variant="outline" className="w-full" asChild>
              <a href="/support">Contact Support</a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}